$( document ).ready(function() {
  $('.product-thumbnail__price:contains(" Free")').text("Get a Quote")
  $('span.money:contains("Free")').text("Get a Quote")
  
  // Fill Salesforce lead hidden field "Product of Interest":
  
  
  // S1780 product page:
  if ( window.location.href.indexOf("request-a-quote") > -1  ) {
  
    
    if ( document.referrer.indexOf('series-1780-thrust-stand') > -1 ) {

        $('#Product_of_interest__c').val('S1780');

    }
    
    
    // S1780 Landing page:
    
      if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/series-1780') > -1 ) {

        $('#Product_of_interest__c').val('S1780');

    }
    
    // Education Kit product page:
    
     
    
    if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/education-kit') > -1 ) {

        $('#Product_of_interest__c').val('Education Kit_1580');

    }
    
    
    // Power supplies product page:
    
     if ( document.referrer.indexOf('https://www.tytorobotics.com/collections/all/products/large-power-supply') > -1 ) {

        $('#Product_of_interest__c').val('Power_supply');

    }
    
   
    
    
    // S1580 product page:
    
    
    if ( document.referrer.indexOf('https://www.tytorobotics.com/products/series-1580-test-stand-bundle') > -1 ) {

        $('#Product_of_interest__c').val('S1580');

    }
    
    // S1580 Landing page:
    
     if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/series-1580-1585') > -1 ) {

        $('#Product_of_interest__c').val('S1580');

    }
    
    // S1520 product page:
    
    if ( document.referrer.indexOf('https://www.tytorobotics.com/collections/all/products/thrust-stand-series-1520') > -1 ) {

        $('#Product_of_interest__c').val('S1520');

    }
    
    // S1520 Landing page:
    
     if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/series-1520') > -1 ) {

        $('#Product_of_interest__c').val('S1520');

    }
    
     // WindShape:
    
     if ( document.referrer.indexOf('www.rcbenchmark.com/pages/wind-tunnel-drone-testing') > -1 ) {

        $('#Product_of_interest__c').val('WS_general');

    }
    
    
    if ( document.referrer.indexOf('www.rcbenchmark.com/products/custom-wind-tunnel') > -1 ) {

        $('#Product_of_interest__c').val('WS_custom');

    }
    
    
    if ( document.referrer.indexOf('https://www.tytorobotics.com/collections/all/products/2x2-windshaper-station') > -1 ) {

        $('#Product_of_interest__c').val('WS_Edu');

    }
    
    
     // Flight stand 15/50 landing page:
    
    if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/flight-stand-15') > -1 ) {

        $('#Product_of_interest__c').val('FS15/50');

    }
    
    
     // Flight stand 15/50 product page:

    if ( document.referrer.indexOf('https://www.tytorobotics.com/products/flight-stand-15') > -1 ) {

        $('#Product_of_interest__c').val('FS15/50');

    }
    
    
     // Flight stand 150 landing page:
    if ( document.referrer.indexOf('https://www.tytorobotics.com/pages/flight-stand-150') > -1 ) {

        $('#Product_of_interest__c').val('FS150');

    }
    

     // Flight stand 150 product page:

    if ( document.referrer.indexOf('https://www.tytorobotics.com/products/flight-stand-150') > -1 ) {

        $('#Product_of_interest__c').val('FS150');

    }
    
    
    
  }

 
  
  
  
  
  /* Cookies */

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  var campaign = getUrlParameter('utm_campaign'); 
  var source = getUrlParameter('utm_source');  
  var medium = getUrlParameter('utm_medium'); 
  
  // Insert cookies in the browser with this information
  
// I retrieve data from my cookie (if it exists) and I create an object in JavaScript.
  
var pepites = new Object();
var pate_cookie = Cookies.get('cookie_utms');
  //console.log (pate_cookie);
  
  
  // If the cookie is present, then get the values from the cookie and not from the URL:
  if ( typeof pate_cookie !== 'undefined'){
  var pate_cookie_values = JSON.parse(pate_cookie);
    
 
  
    // Grab the cookies, if they are present:
  if ( typeof campaign == 'undefined'){
   var campaign = pate_cookie_values['campaign'];
  }
  if ( typeof medium == 'undefined'){
   var medium = pate_cookie_values['medium'];
  }
  if ( typeof source == 'undefined'){
   var source = pate_cookie_values['source'];
  }  
  
  }

  
// If at least one URL parameter exist AND the cookie doesn't exist
  
  
if((source!== false || medium!==false || campaign!==false)) {
  
  //console.log(source);
  //console.log(medium);
  //console.log(campaign);
  
  if(source!== false){ 
    pepites["source"] = source; 
  }
  if(medium!==false){
    pepites["medium"] = medium; 
  }
  if (campaign!==false) {
    pepites["campaign"] = campaign;
  }
  //console.log('utm variables are present in the url');
  Cookies.set('cookie_utms', pepites, { expires: 120 } );
}  
  
  

  // fill the information in a form:
  
  $('input#utm_campaign__c').val( campaign ); 
  $('input#utm_source__c').val( source ); 
  $('input#utm_medium__c').val( medium ); 
  
  if ( medium == 'social' ) {
    $('select#lead_source option:contains("Social")').prop('selected', true);
    
  }
  
  if ( source == 'adwords' && medium == 'ppc' ) {
    $('select#lead_source option:contains("Ads")').prop('selected', true);

  }

  if ( source == 'adwords' && medium == 'ppc' ) {
    $('select#lead_source option:contains("Ads")').prop('selected', true);

  }
  
  if ( source == 'bing' && medium == 'ppc' ) {
    $('select#lead_source option:contains("Ads")').prop('selected', true);
    
  }

  if ( source == 'bing' && medium == 'cpc' ) {
    $('select#lead_source option:contains("Ads")').prop('selected', true);
    
  }

  if ( source == 'hs_email' && medium == 'email' ) {
    $('select#lead_source option:contains("Email marketing")').prop('selected', true);
    
  }
  
  if ( source == 'email_marketing' && medium == 'mailchimp' ) {
    $('select#lead_source option:contains("Email marketing")').prop('selected', true);
    
  }
  
if ( source == 'outreach.io' && medium == 'sales_prospecting' ) {
    $('select#lead_source option:contains("Sales prospecting")').prop('selected', true);
    
  }
  
  if ( source == 'linkedin' && medium == 'cpc' ) {
    $('select#lead_source option:contains("Social")').prop('selected', true);
    
  }
  
  if ( source == 'youtube' && medium == 'cpc' ) {
    $('select#lead_source option:contains("Social")').prop('selected', true);
    
  }
  
  if (medium == 'press-release' ) {
    $('select#lead_source option:contains("Referral")').prop('selected', true);
    
  }

    if (medium == 'referral' ) {
    $('select#lead_source option:contains("Referral")').prop('selected', true);
    
  }
  
    if (medium == 'magazine-ads' ) {
    $('select#lead_source option:contains("Referral")').prop('selected', true);
    
  }
  
  // Save the first page visited as a cookie
  
  var currenturl = Cookies.get('currenturl');
  if ( typeof currenturl == 'undefined'){ 
    var currenturl=window.location.href;
    Cookies.set('currenturl',currenturl, { expires: 120 } );
  } 

  if ( document.getElementById("First_visited_page__c")!=null  ) {
    var quoteSource = '';
    if ( window.location.href.indexOf("request-a-quote") > -1  ) {
      quoteSource = document.referrer;
    } else {
      quoteSource = window.location.href;
    }
       $('#Recent_conversion_url__c').val(quoteSource);    
       $('#First_visited_page__c').val(currenturl);
        $.ajax({
        url: "https://ipapi.co/json/",
        type: "GET",
        crossDomain: true,
        success: function (resp) {
             $('#Recent_conversion_country__c').val(resp.country_name);
        }
      });
  }
 

});